import { useCallback, useEffect, useState } from 'react';

export const OBSERVATION_IDLE_MS = 5 * 60 * 1000;
export function observationAvailability() {
  if (document.visibilityState === 'hidden') return 'hidden';
  if (navigator.onLine === false) return 'offline';
  return null;
}

// Real-time test surfaces observe only while an operator is using the page.
export default function useObservationActivity() {
  const [idle, setIdle] = useState(false);
  const [availability, setAvailability] = useState(observationAvailability);
  const [epoch, setEpoch] = useState(0);
  const resume = useCallback(() => { setIdle(false); setEpoch(value => value + 1); }, []);
  useEffect(() => {
    let timer;
    const arm = () => {
      clearTimeout(timer);
      setIdle(false);
      timer = setTimeout(() => setIdle(true), OBSERVATION_IDLE_MS);
    };
    const activity = () => { if (!observationAvailability()) arm(); };
    const update = () => setAvailability(observationAvailability());
    const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
    events.forEach(name => window.addEventListener(name, activity, { passive: true }));
    document.addEventListener('visibilitychange', update);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    arm();
    return () => {
      clearTimeout(timer);
      events.forEach(name => window.removeEventListener(name, activity));
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, [epoch]);
  const reason = availability || (idle ? 'idle' : null);
  return { active: !reason, reason, resume, epoch };
}
